import { useState } from "react";
import RegisterForm from "./register_content_form";
import PlayerDetail from "../player_ranking/player_ranking_main_section"
import "./register.styles.css";
import { Box, Button, Typography } from "@mui/material";
import useAuth from "../../hooks/useAuth";
import { toast } from "react-toastify";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function RegisterMainSection() {
  const { isAuthenticated, setIsAuthenticated } = useAuth();
  const navigate = useNavigate();

  const [openRegisterDialog, setOpenRegisterDialog] = useState(false);

  const handleOpenDialog = () => setOpenRegisterDialog(true);
  const handleCloseDialog = () => setOpenRegisterDialog(false);

  const handleLogout = async () => {
    try {
      setIsAuthenticated(false);
      const response = await axios.post(
        "https://badmintonnepal.org/api/admin/logout",
        // "http://localhost:8006/api/admin/logout",
        {},
        { withCredentials: true }
      );
      if (response.status === 200) {
        toast.success(response.data?.message || "Logout Success", {
          position: "top-right",
          autoClose: 2000,
          theme: "light",
        });
        navigate("/", { replace: true });
      }
    } catch (err) {
      console.error("Logout Error:", err);
      setIsAuthenticated(false);
      const message = err.response?.data?.message || "Unable To Logout";
      toast.error(message, {
        position: "top-right",
        autoClose: 2000,
        theme: "light",
      });
      navigate("/", { replace: true });
    }
  };

  return (
    <Box className="register__content" >
      <Box
        sx={{
          // border: "1px solid red",
          display: "flex",
          // flexDirection: { xs: "column", sm: "row" },
          width: "90%",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          mb:3
        }}
      >
        <Button 
        
          variant="contained" onClick={handleOpenDialog}
          sx={{
            fontSize:{xs:"12px",sm:"14px"},
            padding:{xs:"5px",sm:"6px 10px"}
          }}
        >
          Player Registration
        </Button>
        {isAuthenticated && (
          <Box>
            <Button
              variant="contained"
              onClick={handleLogout}
              size="small"
              endIcon={<LogoutIcon fontSize="inherit" />}
              sx={{
                padding: { md: "4px 16px", xs: "4px 8px" },
                backgroundColor: "#A91720",
                "&:hover": { backgroundColor: "#8f141c" },
              }}
            >
              <Typography sx={{ fontSize: { md: "14px", xs: "10px" } }}>
                Logout
              </Typography>
            </Button>
          </Box>
        )}
      </Box>
      {/* Render RegisterForm with open/onClose props */}
      <RegisterForm
        open={openRegisterDialog}
        onClose={handleCloseDialog}
      />
      <PlayerDetail />
    </Box>
  );
}

export default RegisterMainSection;